export default {
    show: 'Mostrar',
    'archived': 'archivado',
    'revolved': 'Trasladado',
    'locked': 'Bloqueado',
    active: 'Activo',
    'no-$-financial-files': 'Sin archivos financieros',

    'revolved-to-$': 'Trasladado a {financialFile}',
    "welcome": "Bienvenido",
    "there-is-no-financial-file-so-create-your-financial-file": "Aún no has creado ningún archivo financiero. ¡Comienza creando tu archivo financiero ahora!",
    "create-financial-file": "Crear archivo financiero",
    'did-not-create-any-financial-files': 'Aún no has agregado ningún archivo financiero...',
}